import { getTokenValue, type ThemeState, useThemeObserver } from '@atlaskit/tokens';

import { getLightnessPercentage, increaseLightness, reduceLightness } from '../color-utils';

const BACKGROUND_LIGHTNESS_MAX = 35;
const TEXT_LIGHTNESS_MIN = 90;

export const useDarkModeColors = (getSavedThemeLocal: () => Partial<ThemeState>) => {
	const adsTheme = useThemeObserver();
	const effectiveTheme = process.env.REACT_SSR ? getSavedThemeLocal() : adsTheme;
	const shouldEvaluateLightness = effectiveTheme?.colorMode === 'dark';

	const getDarkModeBackgroundColor = (lightModeColor: string): string => {
		if (lightModeColor === '#FFFFFF') {
			return getTokenValue('elevation.surface', '#1D2125');
		} else {
			const lightnessPercentage = getLightnessPercentage(lightModeColor);
			if (lightnessPercentage === undefined) {
				return lightModeColor;
			}
			return lightnessPercentage > BACKGROUND_LIGHTNESS_MAX
				? reduceLightness(lightModeColor, BACKGROUND_LIGHTNESS_MAX)
				: lightModeColor;
		}
	};

	const getDarkModeCompatibleBackgroundColor = (backgroundColor: string): string => {
		return shouldEvaluateLightness ? getDarkModeBackgroundColor(backgroundColor) : backgroundColor;
	};
	const getDarkModeCompatibleTextColor = (textColor: string): string => {
		return shouldEvaluateLightness ? increaseLightness(textColor, TEXT_LIGHTNESS_MIN) : textColor;
	};

	return {
		shouldEvaluateBackgroundLightness: shouldEvaluateLightness,
		getDarkModeBackgroundColor,
		getDarkModeCompatibleBackgroundColor,
		getDarkModeCompatibleTextColor,
	};
};
